import React, { useEffect } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart as FilledHeart } from "@fortawesome/free-solid-svg-icons";
import { faHeart as OutlinedHeart } from "@fortawesome/free-regular-svg-icons";
import { ProductContext } from "../layout";
import { modifyColor, updateDataLayer } from "../../utils/helpers";

const HeartWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-primary);
  cursor: pointer;
  border: 2px solid var(--color-primary);
  border-radius: 5px;
  transition: all 0.2s ease-in;
  width: ${({ $size }) =>
    $size === "small"
      ? "35px"
      : $size === "medium"
      ? "45px"
      : $size === "large"
      ? "55px"
      : "45px"};
  height: ${({ $size }) =>
    $size === "small"
      ? "35px"
      : $size === "medium"
      ? "45px"
      : $size === "large"
      ? "55px"
      : "45px"};
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: ${({ $size }) =>
      $size === "small"
        ? "35px"
        : $size === "medium"
        ? "45px"
        : $size === "large"
        ? "55px"
        : "45px"};
    height: ${({ $size }) =>
      $size === "small"
        ? "35px"
        : $size === "medium"
        ? "45px"
        : $size === "large"
        ? "55px"
        : "45px"};
  }
  @media (hover: hover) {
    &:hover {
      background-color: ${modifyColor(`var(--color-primary)`, 120)};
      color: var(--color-white);
    }
  }
`;
const LikedHeartWrapper = styled(HeartWrapper)`
  color: var(--color-white);
  background-color: var(--color-primary);
`;

const Heart = styled(FontAwesomeIcon)`
  font-size: ${({ $iconSize }) =>
    $iconSize === "small"
      ? ".9375rem"
      : $iconSize === "large"
      ? "1.25rem"
      : "1.25rem"};
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${({ $iconSize }) =>
      $iconSize === "small"
        ? ".9375rem"
        : $iconSize === "large"
        ? "1.25rem"
        : ".9375rem"};
  }
`;

const ProductHeart = ({ product, priceRaw, size, currency }) => {
  const { setFavouriteList, favouriteList } = React.useContext(ProductContext);
  const [isLiked, setLiked] = React.useState(true);

  useEffect(() => {
    const productExistsInList = JSON.parse(
      localStorage.getItem("favourite-list") || "[]"
    ).filter((p) => p.name === product.name);
    if (productExistsInList.length > 0) {
      setLiked(true);
    } else {
      setLiked(false);
    }
  });

  const clickLike = () => {
    const newFavouriteList = [...favouriteList];
    newFavouriteList.push({
      name: product.name,
      price: product.price,
      image: product.image,
      uri: product.uri,
      productBrands: product.productBrands,
      productCategories: product.productCategories,
      databaseId: product.databaseId,
    });
    setFavouriteList(newFavouriteList);
    setLiked(true);

    if (typeof window === "undefined") {
      return;
    }

    updateDataLayer(async () => {
      window.dataLayer.push({
        event: "wishlist_add",
        ecommerce: {
          currency: currency,
          value: priceRaw,
          items: [
            {
              item_id: product.databaseId,
              item_name: product.name,
              item_category: product.productCategories?.nodes?.[0]?.name,
              item_brand: product.productBrands?.nodes?.[0]?.name,
              price: priceRaw,
              quantity: 1,
            },
          ],
        },
      });
    });
  };

  const clickRemoveLike = () => {
    const newList = favouriteList.filter((p) => p.name !== product.name);
    setFavouriteList(newList);
    setLiked(false);
  };

  return (
    <>
      {!isLiked ? (
        <HeartWrapper $size={size} onClick={clickLike}>
          <Heart icon={OutlinedHeart} $iconSize={size} />
        </HeartWrapper>
      ) : (
        <LikedHeartWrapper $size={size} onClick={clickRemoveLike}>
          <Heart icon={FilledHeart} $iconSize={size} />
        </LikedHeartWrapper>
      )}
    </>
  );
};

ProductHeart.propTypes = {
  product: PropTypes.object,
  currency: PropTypes.string,
  priceRaw: PropTypes.number,
  size: PropTypes.oneOf(["small", "medium", "large"]),
};

export default ProductHeart;
